import styled from 'styled-components'

export default styled.div`
  padding: 10px 15px;
  border-radius: 15px;
  background-color: white;
  color: ${(props) => props.theme.red};
  border: solid 0.9px ${(props) => props.theme.red};
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
  margin-bottom: 15px;
`
